import { all, takeEvery, put, call } from 'redux-saga/effects'
import { notification } from 'antd'
import actions from './actions'
import { list, find, save, remove } from '../../services/users'
import { SAVE_200_MSG, SAVE_200_DESC, DEL_200_MSG, DEL_200_DESC } from '../../constants'

function* fetchUserssRefresh() {
  let fe = JSON.parse(localStorage.getItem('fetchUserss'))
  if (fe == null) {
    fe = {}
    fe.size = localStorage.getItem('pageSize') || 15
    fe.index = 0
    fe.searchTerm = '%20'
    fe.orderBy = '%20'
  } else {
    fe.searchTerm = '%20'
    fe.orderBy = '%20'
  }
  yield put({
    type: actions.REQUESTING,
  })
  const result = yield call(list, fe.size, fe.index, fe.searchTerm, fe.orderBy)
  yield put({
    type: actions.LIST_USERS,
    result,
  })
}
function* fetchUserss() {
  yield put({
    type: actions.REQUESTING,
  })
  const result = yield call(list, 99999, 0, "IsActive:true, Timesheet: true", "Name ASC")
  yield put({
    type: actions.LIST_USERS,
    result,
  })
}

function* fetchUserss2({ size, index, searchTerm, orderBy }) {
  // Load last params froom last session.
  if (!size && !index && !searchTerm && !orderBy) {
    const fe = null // JSON.parse(localStorage.getItem('fetchUserss'))
    if (fe != null) {
      size = fe.size || 15
      index = fe.index || 0
      searchTerm = fe.searchTerm || '%20'
      orderBy = fe.orderBy || '%20'
    } else {
      size = size || localStorage.getItem('pageSize') || 15
      index = 0
      searchTerm = '%20'
      orderBy = '%20'
    }
  }
  localStorage.setItem('fetchUserss', JSON.stringify({ size, index, searchTerm, orderBy }))
  yield put({
    type: actions.REQUESTING,
  })
  const result = yield call(list, size, index, searchTerm, orderBy)
  yield put({
    type: actions.LIST_USERS,
    result,
  })
}

function* fetchUsersEdit({ id }) {
  yield put({
    type: actions.REQUESTING,
  })
  const result = yield call(find, id)
  yield put({
    type: actions.EDIT_USERS,
    result,
  })
}

function* fetchUsersSave(values) {
  yield put({
    type: actions.REQUESTING,
  })
  const result = yield call(save, values)
  if (result !== null) {
    notification.success({ message: SAVE_200_MSG, description: SAVE_200_DESC })
  }
  yield put({
    type: actions.SAVE_USERS_RECIEVED,
    result,
  })
  yield put({
    type: actions.FETCH_PROFILE_CLOSE,
  })
  yield put({
    type: 'user/LOAD_CURRENT_ACCOUNT',
  })
  yield put({
    type: actions.RE_FETCH_USERSS,
  })
}

function* fetchUsersDelete(values) {
  yield put({
    type: actions.REQUESTING,
  })
  const result = yield call(remove, values)
  if (result !== null) {
    notification.success({ message: DEL_200_MSG, description: DEL_200_DESC })
  }
  yield put({
    type: actions.DELETE_USERS_RECIEVED,
    result,
  })
  yield put({
    type: actions.RE_FETCH_USERSS,
  })
}

function* fetchUserProfile({ id }) {
  yield put({
    type: actions.REQUESTING,
  })
  const result = yield call(find, id)
  yield put({
    type: actions.FETCH_PROFILE_SUCCESS,
    result,
  })
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.FETCH_USERSS2, fetchUserss2),
    takeEvery(actions.FETCH_USERSS, fetchUserss),
    takeEvery(actions.FETCH_USERS, fetchUsersEdit),
    takeEvery(actions.SAVE_USERS, fetchUsersSave),
    takeEvery(actions.DELETE_USERS, fetchUsersDelete),
    takeEvery(actions.RE_FETCH_USERSS, fetchUserssRefresh),
    takeEvery(actions.FETCH_PROFILE, fetchUserProfile),
  ])
}
